import Vue from "vue";
import { mapState } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import moedaComponent from "@/components/child/form/moeda.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { ModalButtonAction } from "@/components/child/modal/modalButtonAction";
import searchComboComponent from "@/components/child/searchCombo/search.vue";
import ClienteEditComponent from "@/components/parent/crud/cliente/edit";
import clienteComponent from "@/components/parent/crud/cliente/edit.vue";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component, Watch } from "@/decorators";
import NotaFiscalServicoEletronicaItemModel from "@/models/nfse/notaFiscalServicoEletronicaItemModel";
import NotaFiscalServicoEletronicaModel from "@/models/nfse/notaFiscalServicoEletronicaModel";
import UsuarioModel from "@/models/usuarioModel";
import VendaModel from "@/models/vendaModel";
import NotaFiscalServicoEmissaoService from "@/services/notaFiscal/notaFiscalServicoEmissaoService";
import { AppState } from "@/store/store";
import arithmeticHelper from "@/utils/common/arithmeticHelper";
import { getClienteCombo } from "@/utils/common/combo/combotext";
import Delay from "@/utils/common/delay";

import AdicionarVendaComponent from "./adicionarVenda";
import adicionarVendaComponent from "./adicionarVenda.vue";

@Component({
    components: {
        gridComponent,
        decimalComponent,
        buttonIncluirComponent,
        dataTooltipComponent,
        moedaComponent,
        fieldsetComponent,
        comboComponent,
        clienteComponent,
        actionBarComponent,
        searchComboComponent,
        shortcutComponent,
        adicionarVendaComponent,
    },
    computed: {
        valorTotal() {
            return arithmeticHelper.round(this.item.valorUnitario * this.item.quantidade);
        },
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
    },
})
export default class NfseEditComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("descricao", "Descrição", GridColumnType.String),
            new GridColumn("quantidade", "Qtd.", GridColumnType.Decimal),
            new GridColumn("valorUnitario", "Valor Unit.", GridColumnType.Money),
            new GridColumn("valorTotal", "Valor Total", GridColumnType.Money),
        ];
    }

    extraButtonActionNfse: Array<ModalButtonAction> = [
        new ModalButtonAction("Buscar Venda", "Buscar Venda", true, "l", " btn btn-primary"),
    ];

    private service = new NotaFiscalServicoEmissaoService();
    private model = new NotaFiscalServicoEletronicaModel();
    private item = new NotaFiscalServicoEletronicaItemModel();
    private clienteComponent: ClienteEditComponent = null;
    private shortcutComponent: ShortcutComponent = null;
    private adicionarVendaComponent: AdicionarVendaComponent = null;

    private indexEdditingModel = -1;

    private customComboTextCliente = getClienteCombo;

    private onRemoveItem(item: NotaFiscalServicoEletronicaItemModel) {
        const index = this.model.itens.indexOf(item);
        this.model.itens.splice(index, 1);
    }

    private clear() {
        this.indexEdditingModel = -1;
        this.model = new NotaFiscalServicoEletronicaModel();
        this.item = new NotaFiscalServicoEletronicaItemModel();
    }

    public async emitirNfse() {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                const sucesso = await this.service.emitirNFSE(this.model).withLoading().resolveWithoutJSON();
                if (sucesso) {
                    await this.$showSuccess("NFS-e", "NFS-e enviada com sucesso.");

                    this.$router.back();
                }
            } else {
                this.$focusErrorField();
            }
        } catch {}
    }

    private async onEditItem(item: NotaFiscalServicoEletronicaItemModel) {
        this.item = { ...item };

        this.indexEdditingModel = this.model.itens.indexOf(item);

        if (this.indexEdditingModel < 0) {
            const itensFinded = this.model.itens.filter(
                p => p.descricao == item.descricao && p.quantidade == item.quantidade,
            );
            if (itensFinded.length > 0) {
                this.indexEdditingModel = this.model.itens.indexOf(itensFinded[0]);
            }
        }
    }

    private adicionarItensVenda(venda: VendaModel) {
        venda.itens.forEach(i => {
            this.model.itens.push({ descricao: i.produtoDescricao, ...i } as NotaFiscalServicoEletronicaItemModel);
        });

        if (this.model.clienteId == 0) {
            this.model.clienteId = venda.clienteId;
        }

        if (!this.model.observacao && venda.observacao) {
            this.model.observacao = venda.observacao;
        }

        this.shortcutComponent.hide();
    }

    private async onExtraButtonActionClickNfse(name: string) {
        if (name == "Buscar Venda") {
            this.adicionarVendaComponent.buscarVenda();
        }
    }

    private onAdicionarItem() {
        if (this.indexEdditingModel >= 0) {
            this.model.itens.splice(this.indexEdditingModel, 1);
        }
        this.model.itens.push(this.item);
        this.item = new NotaFiscalServicoEletronicaItemModel();
    }

    private onCancelar() {
        this.clear();
    }

    private cancel() {
        this.$router.back();
    }

    private async onAdicionarVenda() {
        while (!this.$refs.shortcutComponent) await Delay(100);

        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.adicionarVendaComponent = this.$refs.adicionarVendaComponent as AdicionarVendaComponent;

        this.shortcutComponent.title = this.$t("__.ts.buscarVenda").toString();

        this.shortcutComponent.show();
    }

    private async openNewCliente() {
        this.clienteComponent = this.$refs.clienteComponent as ClienteEditComponent;
        this.clienteComponent.modelId = null;
        this.clienteComponent.load();
    }

    private async openComboEditCliente(id: number) {
        this.clienteComponent = this.$refs.clienteComponent as ClienteEditComponent;
        this.clienteComponent.modelId = id;
        this.clienteComponent.load();
    }

    private async onAddCliente(closeModal) {
        if (await this.clienteComponent.save()) {
            closeModal();
        }
    }

    @Watch("valorTotal")
    private onCalculateValorTotal() {
        this.item.valorTotal = this["valorTotal"];
    }
}
